var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ui-field"},[(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('input',_vm._b({staticClass:"ui-input",attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'input',_vm.$attrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }